import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDLchRWgDoSMP_aBlnl4vD0UtbTowuYDBs",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "vilora-impex.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "vilora-impex",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "vilora-impex.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "473779640550",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:473779640550:web:717ed1374bc4d27ba68327",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-83W549G38V",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
